export default __webpack_public_path__ + "static/media/kbapk.b4aee5d8.png";